import {Pipe, PipeTransform} from '@angular/core';
import {DateUtility} from '../../utils/date-utility';

@Pipe({
  name: 'getFrequency',
  pure: true,
})
export class GetFrequencyPipe implements PipeTransform {
  constructor(private dateUtility: DateUtility) {}

  transform(value: any, ...args: any[]): any {
    return this.dateUtility.getFrequency(value);
  }
}
